var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show && _vm.options.length > 1)?_c('b-select',{staticClass:"mb-2",attrs:{"value":_vm.value,"options":_vm.options,"value-field":"column","text-field":"name"},on:{"input":function($event){return _vm.$emit('input', $event)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }